"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getConfirmationRequest = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _reselect = require("reselect");

var _constants = require("./constants");

var getPortalId = function getPortalId(state) {
  return state.auth.portal.portal_id;
};

var getUserEmail = function getUserEmail(state) {
  return state.auth.user.email;
};

var getRedirectUrl = function getRedirectUrl() {
  return window.location.origin + "/settings-sso-confirm";
};

var getConfirmationRequest = (0, _reselect.createSelector)([getPortalId, getUserEmail, getRedirectUrl], function (portalId, userEmail, redirectUrl) {
  var _ref;

  return _ref = {}, (0, _defineProperty2.default)(_ref, _constants.LOGIN_PORTAL_ID, portalId), (0, _defineProperty2.default)(_ref, _constants.EMAIL, userEmail), (0, _defineProperty2.default)(_ref, _constants.LOGIN_REDIRECT_URL, redirectUrl), (0, _defineProperty2.default)(_ref, _constants.LOGIN_TYPE, _constants.CONFIRMATION), _ref;
});
exports.getConfirmationRequest = getConfirmationRequest;